// extracted by mini-css-extract-plugin
module.exports = {"container":"BottomOptions_container__2Iu1r","resizeTip":"BottomOptions_resizeTip__1WWRs"};